import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa6';
import List from './components/List';
import Modal from './components/Modal';

const DutyList = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="p-3 rounded-2">
      <div className="d-flex w-100">
        <h4>Duties/Teams</h4>
        <Button className="ms-auto btn-transparent" onClick={() => setShowModal(true)}>
          {' '}
          <FaPlus />
        </Button>
      </div>
      <List />
      <Modal show={showModal} handleShow={() => setShowModal(false)} />
    </div>
  );
};

export default DutyList;
